<template>
    <v-list nav dense>
        <template>
            <v-list-item link router to="/home" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-home</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('inicio') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-group prepend-icon="mdi-golf" no-action color="white">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>Golf</v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item link router to="/golf/courts" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-soccer-field</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_courts') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/golf/blacklist" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-account-cancel</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_blacklist') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-group sub-group no-action color="white">
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>Starter</v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item link router to="/golf/reservations" class="list" active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>mdi-calendar-clock</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('golf_reservations') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item link router to="/golf/caddies" class="list" active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>mdi-account-tie</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('golf_caddies') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list-group>

            <v-list-item link router to="/notices" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-bullhorn</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Notices') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/settings" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('configuracion') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/ayuda" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-help-circle</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Ayuda') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'golf_admin',
  computed: {
    ...mapGetters(['getProfile'])
  }
}
</script>

<style scoped>
.list:hover {
    background: white;
    opacity: 0.85;
}
</style>
